<template lang="pug">
  v-app(id="app")
    v-content
      Navbar
      v-container(fluid).layout-public-main
        router-view
</template>

<script>

import Navbar from '@/components/login/Navbar'

export default {
  name: 'Public',
  data () {
    return {}
  },
  mounted () {
    this.$amplitude.getInstance().identify(new this.$amplitude.Identify())
  },
  components: {
    Navbar
  }
}
</script>

<style>
  #loader { text-align: center; }
  #mob-footer p a {
    color: var(--second-brand-color);
  }
  .back-to a span {
    color: #1745A8;
    font-size: 3em;
    left: 1em;
  }
  .images-slides { background-color: #E8E8E8; }

  .layout-public-main {
    padding: 0!important;
  }
  @media (max-width: 767.98px) {
    img#logo {
      width: 40%;
    }
    .login__wrapper .container__logo {
      text-align: center;
      background-color: #0855C4;
      padding-top: 11px;
      padding-bottom: 5px;
    }
  }
  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
    .login__wrapper {
      background-color: #0855C4;
      padding: 0;
    }
    .login__wrapper .container__logo {
      padding: 8px 0 3px 10%;
    }
    .login__wrapper img {
      width: 13%;
    }
    .container.fluid {
      padding: 0;
    }
  }
  @media only screen  and (min-width : 1750px) {
    form#login-form .v-text-field .v-input__control .v-input__slot .v-input__prepend-inner {
      width: 6%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Public.vue